import lodashCloneDeep from "lodash.clonedeep";

/**
 * Creates a deep copy of the given value without references.
 * @param {any} value
 * @return {any}
 */
export function cloneDeep(value) {
    return lodashCloneDeep(value);
}

/** 
 * Not used because translates Array to Object
*/
export function cloneDeepManual(obj) {
    // Create new object with same prototype
    const clone = Object.create(Object.getPrototypeOf(obj));

    // Copy own properties (deeply, if needed)
    for (const key of Reflect.ownKeys(obj)) {
        const value = obj[key];
        clone[key] = (typeof value === "object" && value !== null)
            ? cloneDeep(value)
            : value;
    }

    return clone;
}